import React, { FC } from 'react'

import { SecondTry as SecondTryUnwrapped } from './SecondTry'
import { SecondTryProvider } from './SecondTryContext/SecondTryProvider'

export const SecondTry: FC = () => {
  return (
    <SecondTryProvider>
      <SecondTryUnwrapped />
    </SecondTryProvider>
  )
}
